<script>
export default {
  name: "BaseSplitterPanel",
  props: {
    size: {
      type: Number,
      default: null
    },
    minSize: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isNested: false
    };
  },
  computed: {
    rootClasses() {
      return ["p-splitter-panel", { "p-splitter-panel-nested": this.isNested }];
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isNested = this.$el.parentElement.classList.contains(
        "p-splitter-panel"
      );
    });
    this.$emit("nestedStatusChanged", this.isNested);
  }
};
</script>
<style>
.p-splitter-panel {
  flex-grow: 1;
}

.p-splitter-panel-nested {
  display: flex;
}

.p-splitter-panel .p-splitter {
  flex-grow: 1;
  border: 0 none;
}
</style>
